<template>
    <view-listing-link :listing="listing" class="btn btn-lg btn-block btn-primary border-2 rounded-full font-semibold text-xl">
        <i v-cloak v-if="listing.active && listing.stocked" class="fad fa-shopping-cart fa-lg mr-2"></i>
        <i v-cloak v-else class="fad fa-external-link-square fa-lg mr-2"></i>
        <span v-cloak v-if="listing.active && listing.stocked">
            Buy Now
        </span>
        <span v-cloak v-else>
            View Item
        </span>
    </view-listing-link>
</template>

<script>
export default {
    props: ['listing'],

    data: () => ({}),

    created() {},

    mounted() {},

    computed: {},

    methods: {}
}
</script>

<style lang="scss" scoped>
</style>
